import Vue from 'vue';
import './plugins/vuetify'
import App from './App.vue';
import router from './router';
import storeListener from './storeListener';
import store from './store';
import './registerServiceWorker';
import moment from 'moment';
import VueMomentJS from 'vue-momentjs';
Vue.use(VueMomentJS, moment);

const debug = false;

Vue.config.productionTip = false;
Vue.config.devtools = true;

import 'material-design-icons-iconfont/dist/material-design-icons.css'

storeListener.onAuthUserReady((user) => {
  if (debug) console.log('main - storeListener.onAuthUserReady() user:',user)
  // Launch app only first time
  new Vue({
    router,
    store,
    render: h => h(App)
  }).$mount('#app')
})
